@use '@lib/assets/styles/main.scss' as *;

$imageSize: 48px;

.wrap {
  padding-left: $imageSize + 8px;
  position: relative;
}

.wrapDisabled {
  @extend %disabledGrayscale;
}

.icon {
  position: absolute;
  top: 0;
  left: 0;
  width: $imageSize;
  img, svg {
    display: block;
    max-width: 100%;
    height: auto;
  }
  img {
    object-fit: cover;
    width: $imageSize;
    height: $imageSize;
    border-radius: 4px;
    border: 1px solid $gray200;
  }
}

.warningIcon {
  float: left;
  color: $warning900;
  margin-right: 4px;
  padding-top: 2px;
  & * {
    display: block;
  }
}

.info {
  min-height: 48px;
  display: flex;
  align-items: center;
  & > * {
    display: block;
    word-break: break-word;
    & + * {
      margin-top: -4px;
    }
  }
}
